import { FeathersModel } from './feathersModel'
import { Worker } from './worker'
import { Allocation } from './Allocation'
import { DateUtils } from '../services/date-utils.service'

export class WorkerAllocation extends FeathersModel {
  static serviceName = 'worker-allocations'

  workerId: number
  worker: Worker

  allocationId: number
  allocation: Allocation

  keyWorkerId: number | null
  keyWorker: Worker | null

  coordinatorNote: string | null
  deactivatedAt: Date | null
  deactivationReason: string | null
  isDeactivated: boolean

  isInactive() {
    return DateUtils.canBeParsedToDate(this.deactivatedAt)
  }
}
